import { Col, Divider, Form, Row } from 'antd';
import { cloneDeep } from 'es-toolkit';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { MODULES_ID } from '../../../../../../../contants/common';
import useDocsExtentions from '../../../../../../../redux/hooks/useDocsExtentions';
import { routeFileSelector } from '../../../../../../../utilz/i18n';
import Button from '../../../../../../components/Buttons/Button';
import HiddenFormInput from '../../../../../../components/Inputs/HiddenFormInput';
import TMSFilesDetailsCard from '../../../Tabs/FilesDetails/TMSFilesDetailsCard';

const TMSDocumentDetails = () => {
  const [form] = Form.useForm();
  const allowedExtentions = useDocsExtentions(MODULES_ID.SHIPMENT);
  const documents = Form.useWatch('documents', form);

  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const handleAddNew = () => {
    const documentsLocal = cloneDeep(documents);
    documentsLocal.push({ renderKey: uuidv4(), isNew: true });
    form.setFieldValue('documents', documentsLocal);
  };

  const handleDelete = (index) => {
    const documentsLocal = cloneDeep(documents);
    documentsLocal.splice(index, 1);
    form.setFieldValue('documents', documentsLocal);
  };

  const handleSave = (data, fileInput, index) => {
    const documentsLocal = cloneDeep(documents);
    documentsLocal[index] = {
      ...documentsLocal[index],
      ...data,
    };
    const reader = new FileReader();
    reader.readAsDataURL(fileInput);
    reader.onload = () => {
      documentsLocal[index].fileBase64 = reader.result;
      form.setFieldValue('documents', documentsLocal);
    };
  };

  const uploadedDocumentTypes = useMemo(
    () =>
      (documents ? documents.map(({ fileType }) => (fileType ? fileType : false)) : [])?.filter((val) => Boolean(val)),
    [documents],
  );

  return (
    <>
      <Form form={form} className="d-none" name="documentForm" initialValues={{ documents: [] }}>
        <HiddenFormInput name="documents" />
      </Form>
      <div className="d-flex h-100" style={{ flexDirection: 'column' }}>
        <Row justify="end" gutter={16} align="middle">
          <Col>
            <Button onClick={handleAddNew}>{t('translation:default.documentManager.addNewFile')}</Button>
          </Col>
        </Row>
        <Divider className="my-16 vw-100 ml-n30" />
        <div>
          {documents?.length > 0 ? (
            documents.map((row, index) => (
              <TMSFilesDetailsCard
                key={row.renderKey}
                fileDetails={row}
                handleDelete={handleDelete}
                handleSaveForAddNewScreen={handleSave}
                isNew={row.isNew}
                index={index}
                uploadedDocumentTypes={uploadedDocumentTypes}
                allowedExtentions={allowedExtentions}
              />
            ))
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default TMSDocumentDetails;
